package gr.tech.pdfgenerator.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import gr.tech.pdfgenerator.components.layouts.AuthPageLayout
import gr.tech.pdfgenerator.models.user.USER_ROLES
import gr.tech.pdfgenerator.navigation.SitePage

@Page
@Composable
fun IndexPage() {
    AuthPageLayout(
        title = "Home",
        redirectIfLoggedIn = SitePage.Projects.route,
        requiredRoles = listOf(USER_ROLES.CONFIRMED_USER.role)
    ) {
        IndexScreen()
    }
}

@Composable
fun IndexScreen() {}
